<template>
    <li><slot></slot></li>
</template>

<script>
export default {
    name: 'ListCard'
}
</script>

<style scoped>

</style>
